import { render, staticRenderFns } from "./staffSelector.vue?vue&type=template&id=dfdaedec&scoped=true&"
import script from "./staffSelector.vue?vue&type=script&lang=js&"
export * from "./staffSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfdaedec",
  null
  
)

export default component.exports